import React from "react";
import PropTypes from "prop-types";
import {getDefaultFieldLabel} from "../../../../utilities/helperFunctions";
import BaseFieldComponent from "../BaseFieldComponent";
import GenericSwitchInput from "../../../base/input/GenericSwitchInput";
import SelectChipContainer from "../../../../connectui/component/input/SelectChipContainer";
import {fieldParams} from "configuration/specs";

const CheckBoxField = ({fieldData, handleValueChange, options, ...props}) => {
  const renderInput = () => (
    <GenericSwitchInput
      value={fieldData.val}
      edit={true}
      onValueChange={(e) => {
        handleValueChange(fieldData.type, e);
      }}
    />
  );

  const renderFilter = () => {
    const fieldSpec = fieldParams[fieldData.field];
    const customOptions = fieldSpec?.options;

    if (customOptions && Array.isArray(customOptions)) {
      const chipOptions = [];
      const optionMap = {};

      customOptions.forEach((optionObj) => {
        Object.entries(optionObj).forEach(([boolValue, label]) => {
          chipOptions.push(label);
          optionMap[label] = boolValue === "true";
        });
      });

      const currentSelection = [];
      if (fieldData.val !== undefined && fieldData.val !== null) {
        const selectedOption = customOptions.find(
          (optionObj) => Object.keys(optionObj)[0] === String(fieldData.val),
        );
        if (selectedOption) {
          currentSelection.push(Object.values(selectedOption)[0]);
        }
      }

      return (
        <SelectChipContainer
          options={chipOptions}
          selectedOptions={currentSelection}
          onChange={(newSelection) => {
            if (newSelection.length === 0) {
              handleValueChange("custom", []);
            } else {
              const selectedLabel = newSelection[0];
              const boolValue = optionMap[selectedLabel];
              handleValueChange("custom", [
                {path: fieldData.field, value: boolValue},
              ]);
            }
          }}
          multiSelect={false}
        />
      );
    }

    return renderInput();
  };

  const getOperators = () => ["is"];

  const getLabel = () => {
    const fieldSpec = fieldParams[fieldData.field];
    const customOptions = fieldSpec?.options;

    if (
      customOptions &&
      Array.isArray(customOptions) &&
      fieldData.val !== undefined
    ) {
      const selectedOption = customOptions.find(
        (optionObj) => Object.keys(optionObj)[0] === String(fieldData.val),
      );
      if (selectedOption) {
        return Object.values(selectedOption)[0];
      }
    }

    return getDefaultFieldLabel(fieldData?.val);
  };

  return (
    <BaseFieldComponent
      renderInput={renderInput}
      getLabel={getLabel}
      renderFilter={renderFilter}
      getOperators={getOperators}
      {...props}
    />
  );
};

CheckBoxField.propTypes = {
  fieldData: PropTypes.object.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
};

export default CheckBoxField;
